import { render, staticRenderFns } from "./develoment-path.vue?vue&type=template&id=3fca7d3c&scoped=true"
import script from "./develoment-path.vue?vue&type=script&lang=js"
export * from "./develoment-path.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fca7d3c",
  null
  
)

export default component.exports